import { take } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { appSettings } from './../../../../../environments/app.setings';
import { FichaService } from '../../../ficha-veiculo.service';
import { FichaModalAvalistaComponent } from './../../ficha-modal-avalista/ficha-modal-avalista.component';
import { CustomModalService } from '../../../../shared/modais/custom-modal/custom-modal.service';
import { Component, OnInit, Input } from '@angular/core';
import { FichaCadastro } from '../../../../../app/ficha-veiculo/ficha-cadastro/ficha-cadastro';

@Component({
  selector: 'app-avalista',
  templateUrl: './avalista.component.html',
  styleUrls: ['./avalista.component.css'],
})
export class AvalistaComponent implements OnInit {
  @Input() acoes: any;
  @Input() idFicha: number;
  @Input() cpfCliente: any;
  @Input() fichaCadastro: FichaCadastro;
  @Input() isPj: boolean = false;
  bsModalRef: BsModalRef;
  isAvalistaObrigatorio: boolean;

  proposta: any;

  constructor(
    private modalService: CustomModalService,
    private fichaService: FichaService
  ) {}

  ngOnInit() {}

  public openModalWithComponent() {
    this.fichaCadastro.proposta.id = this.idFicha;
    const initialState = {
      fichaCadastro: this.fichaCadastro,
      avalistasIncluidos: [],
      isPj: this.isPj,
    };
    this.bsModalRef = this.modalService.show(FichaModalAvalistaComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });
    this.bsModalRef.content.cpfCliente = this.cpfCliente;
    (<FichaModalAvalistaComponent>(
      this.bsModalRef.content
    )).onCloseModal.subscribe((body) => (this.proposta = body));
    this.isAvalistaObrigatorio = false;
  }

  pushAvalista() {
    this.proposta.id = this.idFicha;
    return this.fichaService
      .pushAvalista({ proposta: this.proposta })
      .pipe(take(1))
      .subscribe();
  }

  validaEnvio(): boolean {
    if (this.proposta) {
      this.isAvalistaObrigatorio = false;
      return true;
    }
    this.isAvalistaObrigatorio = true;
    return false;
  }

  public hasIncluirAvalista(): boolean {
    if (this.acoes) {
      return JSON.stringify(this.acoes).includes('INCLUIR_AVAL');
    }
  }
}
